module.exports = __webpack_public_path__ + "img/empty-small.30c9890e.svg";